export const firebaseConfig = {
  apiKey: "AIzaSyB7e731lyA5FoL6DNoBuHG6o9qlDP7xgks",
  authDomain: "kallossoft-f4116.firebaseapp.com",
  projectId: "kallossoft-f4116",
  storageBucket: "kallossoft-f4116.appspot.com",
  messagingSenderId: "928741453216",
  appId: "1:928741453216:web:491d9c8fe217c6775ec8c5",
  measurementId: "G-4PT4FPK5DJ"
};
